/**
 * LAPP VN — Theme DataLayer Events
 * dataLayer pushes only. No GTM/GA4 code lives here — the container is
 * already loaded via the Shopify Custom Pixel (Customer Events).
 *
 * Covers: select_item, add_to_cart, remove_from_cart,
 *         view_promotion, select_promotion, view_cart (drawer open)
 *
 * Page-load events (view_item, view_item_list, view_cart on /cart,
 * generate_lead, sign_up) are pushed inline via Liquid in their
 * respective section/template files — see implementation notes.
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  function pushEvent(payload) {
    window.dataLayer.push({ ecommerce: null }); // clear previous ecommerce object
    window.dataLayer.push(payload);
  }

  // ---------------------------------------------------------------------
  // Searchnize app — collection/search grids on this store are rendered
  // by the Searchnize app (AJAX-injected light DOM, not shadow DOM), which
  // bypasses the theme's native product-card.liquid entirely. Track
  // view_item_list and select_item against Searchnize's own markup.
  // ---------------------------------------------------------------------
  function parseSnizeItem(li) {
    if (!li) return null;
    var titleEl = li.querySelector('.snize-title');
    var attrEls = li.querySelectorAll('.snize-overhidden > .snize-attribute');
    // First .snize-attribute is "Article No.: X", last is vendor/brand
    var brand = attrEls.length ? attrEls[attrEls.length - 1].textContent.trim() : '';
    var priceEl = li.querySelector('.snize-price, .money'); // only present when pricing is visible (logged in)

    var categoryMatch = (li.className || '').match(/snize-product-tag-cat_([a-z0-9-]+)/i);

    var item = {
      item_id: li.getAttribute('data-original-product-id') || '',
      item_name: titleEl ? titleEl.textContent.trim() : '',
      item_brand: brand,
      item_category: categoryMatch ? categoryMatch[1].replace(/-/g, ' ') : ''
    };
    if (priceEl) {
      var priceNum = parseFloat((priceEl.textContent || '').replace(/[^0-9.]/g, ''));
      if (!isNaN(priceNum)) item.price = priceNum;
    }
    return item;
  }

  // select_item — click on a Searchnize product card
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('a.snize-view-link');
    if (!link) return;
    var li = link.closest('li.snize-product');
    if (!li) return;

    var item = parseSnizeItem(li);
    if (!item || !item.item_id) return;

    pushEvent({
      event: 'select_item',
      ecommerce: { item_list_name: 'Collection Grid', items: [item] }
    });
  });

  // view_item_list — fires whenever Searchnize (re)renders its results
  // grid: initial load, pagination, or filter changes.
  function initSearchnizeListTracking() {
    if (window.__dlSearchnizeListTrackingInit) return;
    window.__dlSearchnizeListTrackingInit = true;

    var attempts = 0;
    var maxAttempts = 40; // poll up to ~20s for the results container to exist

    function tryAttach() {
      attempts++;
      var container = document.querySelector('.snize-search-results-content');

      if (container) {
        var lastSignature = '';

        function pushListIfChanged() {
          var items = Array.prototype.slice
            .call(container.querySelectorAll('li.snize-product'))
            .map(parseSnizeItem)
            .filter(function (i) { return i && i.item_id; });

          if (!items.length) return;

          var signature = items
            .map(function (i) { return i.item_id; })
            .slice()
            .sort()
            .join(',');
          if (signature === lastSignature) return;
          lastSignature = signature;

          pushEvent({
            event: 'view_item_list',
            ecommerce: { item_list_name: document.title || 'Collection', items: items }
          });
        }

        var observer = new MutationObserver(function () {
          // Debounce: Searchnize may mutate the DOM several times in quick
          // succession while rendering a new result set.
          clearTimeout(container._dlDebounce);
          container._dlDebounce = setTimeout(pushListIfChanged, 300);
        });
        observer.observe(container, { childList: true, subtree: false });

        pushListIfChanged(); // in case results are already present
        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(tryAttach, 500);
      }
    }

    tryAttach();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchnizeListTracking);
  } else {
    initSearchnizeListTracking();
  }

  // ---------------------------------------------------------------------
  // select_item — delegated click on any product card
  // Fires from: Collection page, Search results, Recommendation block
  // Requires data-dl-item + data-dl-list attributes on <product-card>
  // (added in snippets/product-card.liquid)
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (evt) {
    var card = evt.target.closest('[data-dl-item]');
    if (!card) return;

    var link = evt.target.closest('a');
    if (!link) return; // only fire on actual navigation clicks, not swatch/quick-add taps

    try {
      var item = JSON.parse(card.getAttribute('data-dl-item'));
      pushEvent({
        event: 'select_item',
        ecommerce: {
          item_list_name: card.getAttribute('data-dl-list') || 'Product Grid',
          items: [item]
        }
      });
    } catch (e) {
      console.warn('datalayer-events: could not parse data-dl-item', e);
    }
  });

  // ---------------------------------------------------------------------
  // add_to_cart — theme already dispatches 'cart:item-added' on
  // successful AJAX add (assets/product.js). Reuse it directly.
  // ---------------------------------------------------------------------
  document.addEventListener('cart:item-added', function (evt) {
    var product = evt.detail && evt.detail.product;
    if (!product) return;

    pushEvent({
      event: 'add_to_cart',
      ecommerce: {
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : undefined,
        value: (product.final_line_price || product.price * product.quantity) / 100,
        items: [{
          item_id: product.product_id || product.id,
          item_name: product.product_title || product.title,
          item_variant: product.variant_title,
          item_brand: product.vendor,
          item_category: product.product_type,
          price: (product.price || 0) / 100,
          quantity: product.quantity
        }]
      }
    });
  });

  // ---------------------------------------------------------------------
  // remove_from_cart — snapshot the line item BEFORE it's removed from
  // the DOM (the 'cart:remove' event fires pre-fetch, so the row still
  // has its data-dl-item attribute at this point).
  // Requires data-dl-item on cart item rows (main-cart.liquid,
  // snippets/cart-drawer.liquid)
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (evt) {
    var removeBtn = evt.target.closest('cart-remove');
    if (!removeBtn) return;

    var row = removeBtn.closest('[data-dl-item]');
    if (!row) return;

    try {
      var item = JSON.parse(row.getAttribute('data-dl-item'));
      pushEvent({
        event: 'remove_from_cart',
        ecommerce: { items: [item] }
      });
    } catch (e) {
      console.warn('datalayer-events: could not parse data-dl-item on remove', e);
    }
  });

  // ---------------------------------------------------------------------
  // view_cart — fires when the cart drawer is opened.
  // (Cart PAGE view_cart is pushed inline via Liquid in main-cart.liquid,
  // since that's a full page load.)
  // Requires a data-dl-cart JSON attribute on the <cart-drawer> element,
  // refreshed by the theme whenever the drawer section re-renders.
  // ---------------------------------------------------------------------
  document.addEventListener('cart-drawer:open', function () {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || !drawer.hasAttribute('data-dl-cart')) return;

    try {
      var cart = JSON.parse(drawer.getAttribute('data-dl-cart'));
      pushEvent({
        event: 'view_cart',
        ecommerce: cart
      });
    } catch (e) {
      console.warn('datalayer-events: could not parse data-dl-cart', e);
    }
  });

  // ---------------------------------------------------------------------
  // view_promotion / select_promotion
  // Requires data-dl-promo on each promotion block (sections/promotion-blocks.liquid)
  // ---------------------------------------------------------------------
  var seenPromotions = new Set();

  function firePromotionView(el) {
    var id = el.getAttribute('data-dl-promo-id');
    if (seenPromotions.has(id)) return; // once per page view
    seenPromotions.add(id);

    try {
      var promo = JSON.parse(el.getAttribute('data-dl-promo'));
      pushEvent({ event: 'view_promotion', ecommerce: promo });
    } catch (e) {
      console.warn('datalayer-events: could not parse data-dl-promo', e);
    }
  }

  function initPromotionObserver() {
    var promoEls = document.querySelectorAll('[data-dl-promo]');
    if (!promoEls.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: treat all as viewed immediately
      promoEls.forEach(firePromotionView);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          firePromotionView(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    promoEls.forEach(function (el) { observer.observe(el); });
  }

  document.addEventListener('click', function (evt) {
    var promoEl = evt.target.closest('[data-dl-promo]');
    if (!promoEl) return;
    var link = evt.target.closest('a');
    if (!link) return;

    try {
      var promo = JSON.parse(promoEl.getAttribute('data-dl-promo'));
      pushEvent({ event: 'select_promotion', ecommerce: promo });
    } catch (e) {
      console.warn('datalayer-events: could not parse data-dl-promo on click', e);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromotionObserver);
  } else {
    initPromotionObserver();
  }

  // Re-scan for promotions after any section re-render (e.g. AJAX filters)
  document.addEventListener('shopify:section:load', initPromotionObserver);

  // ---------------------------------------------------------------------
  // sign_up — create_customer form redirects to the account page on
  // success (no re-render to hook via Liquid), so we flag it via a
  // return_to query param (see sections/main-register.liquid) and catch
  // it here once, then strip it from the URL to prevent re-firing on
  // refresh/back navigation.
  // ---------------------------------------------------------------------
  function checkSignupFlag() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('dl_signup') !== '1') return;

    pushEvent({ event: 'sign_up', method: 'email' });

    params.delete('dl_signup');
    var newSearch = params.toString();
    var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkSignupFlag);
  } else {
    checkSignupFlag();
  }

  // ---------------------------------------------------------------------
  // sign_up (B2B Registration) — this form is rendered by Shopify's
  // native Forms app inside a Shadow DOM (<shopify-forms-embed>), so
  // standard click delegation can't reach it (click events get
  // retargeted to the shadow host before bubbling to document).
  // Instead, watch the form's own step-tracking attribute for a change
  // away from "form", which indicates successful submission.
  // NOTE: relies on Shopify Forms app internals (data-current-step) —
  // not a documented public API. Verify this still works after any
  // Shopify Forms app update.
  // ---------------------------------------------------------------------
  function initB2BFormTracking() {
    var attempts = 0;
    var maxAttempts = 40; // poll for up to ~20 seconds, since the Forms app renders asynchronously

    function tryAttach() {
      attempts++;
      var host = document.querySelector('shopify-forms-embed');

      if (host && host.shadowRoot) {
        if (host.dataset.b2bTrackingBound) return;
        host.dataset.b2bTrackingBound = '1';

        var fired = false;

        function checkStep() {
          if (fired) return;
          var root = host.shadowRoot.querySelector('[data-form-root]');
          if (!root) return;
          var currentStep = root.getAttribute('data-current-step');
          if (currentStep && currentStep !== 'form') {
            fired = true;
            pushEvent({ event: 'sign_up', method: 'b2b_registration_form' });
            observer.disconnect();
          }
        }

        var observer = new MutationObserver(checkStep);
        observer.observe(host.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-current-step']
        });

        checkStep(); // in case it's already past the "form" step
        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(tryAttach, 500);
      }
    }

    tryAttach();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initB2BFormTracking);
  } else {
    initB2BFormTracking();
  }

})();